import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {RouterLink} from '@angular/router';

import {MenuItem} from '../../../../app.constants';
import {IsRouteActivePipe} from '../pipes/is-route-active.pipe';
import {NgClass} from '@angular/common';

@Component({
  selector: 'route-item-group',
  standalone: true,
  imports: [MatIconModule, RouterLink, IsRouteActivePipe, NgClass],
  templateUrl: './route-item-group.component.html',
  styleUrl: './route-item-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouteItemGroupComponent {
  isMobile = input<boolean>(false);
  menuItems = input<MenuItem[]>([]);
  featuredRoutes = input<MenuItem[]>([]);
  routerUrl = input<string>();
  menuItemClick = output<void>();
  metaItemClick = output<MenuItem>();

  featuredItems = computed(() => {
    if (this.isMobile()) return [];
    const menuItems = this.menuItems();
    const routes = this.featuredRoutes();
    // Get the itemGroup from the first menu item that has one
    const itemGroup = menuItems.find(item => item.itemGroup)?.itemGroup;
    if (!itemGroup) return [];
    // Only show featured routes that match the same itemGroup
    return routes.filter(item => item.itemGroup === itemGroup);
  });

  regularItems = computed(() => {
    if (this.isMobile()) return this.menuItems();
    const featuredUrls = this.featuredItems().map(item => item.url);
    return this.menuItems().filter(item => !featuredUrls.includes(item.url));
  });

  onMenuItemClick(): void {
    this.menuItemClick.emit();
  }

  onMetaItemClick(item: MenuItem): void {
    if (!item?.meta) return;
    this.metaItemClick.emit(item);
  }
}
